import { Card } from "../general/card";
import { Metric } from "../general/custom";
import { Box } from "@mui/material";
import Loader from "../general/loader";
import { formatEnergy } from "../../scripts/utils";

export default function GeneralInfo({ productionData, generalData, isFetchingProductionData, isFetchingGeneralData }) {
  const totalOfftake = generalData?.grid_offtake ? Number(generalData.grid_offtake.toFixed(2)) : null;
  const totalInjection = generalData?.grid_inject ? Number(generalData.grid_inject.toFixed(2)) : null;
  const totalProduction = productionData?.total_production ? Number(productionData.total_production.toFixed(2)) : null;
  const totalConsumption = generalData?.total_consumption ? Number(generalData.total_consumption.toFixed(2)) : null;

  const isFetching = isFetchingProductionData || isFetchingGeneralData;
  return (
    <Card display="flex" flexDirection="column" justifyContent="center" alignItems="center" title="General statistics">
      {isFetching ? (
        <Loader />
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            rowGap: 1,
            columnGap: { xs: 0, sm: 1 },
          }}
        >
          <Metric name="Total Offtake" value={formatEnergy(totalOfftake)} width={{ xs: 120, sm: 170, md: 200 }} />
          <Metric name="Total Injection" value={formatEnergy(totalInjection)} width={{ xs: 120, sm: 170, md: 200 }} />
          <Metric name="Total Production" value={formatEnergy(totalProduction)} width={{ xs: 120, sm: 170, md: 200 }} />
          <Metric
            name="Total Consumption"
            value={formatEnergy(totalConsumption)}
            width={{ xs: 120, sm: 170, md: 200 }}
          />
        </Box>
      )}
    </Card>
  );
}
